import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const addressMapBlockDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.addressMap,
  componentType: LAYOUT_COMPONENT_TYPE.addressMapBlock,
  registryBlockKey: REGISTRY_BLOCK.presentation.addressMapBlock,
  displayOrder: 3,
  content: {
    sectionTitle: loc3('Standort', 'Location', 'Địa điểm'),
    address: loc3(
      'Mühlgasse 8 · 80469 München',
      '8 Mühlgasse · Munich',
      '8 Mühlgasse · Munich',
    ),
    directions: loc3(
      'Zwei Minuten vom Isartor — Fahrradständer vor der Tür.',
      'Two minutes from Isartor — bike racks at the door.',
      'Cách Isartor hai phút — chỗ để xe đạp trước cửa.',
    ),
  },
  media: {
    mapImage:
      'https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=1400&q=80',
  },
};
